import { COMPANY, SERVICES } from './content';

export function Contact() {
  return (
    <>
      <section className="page-head">
        <p className="eyebrow">Contact</p>
        <h1>Tell us what you need built</h1>
        <p className="hero-lead">
          Email is the fastest way to reach us, and it reaches a person rather
          than a ticket queue.
        </p>
      </section>

      <section className="band">
        <div className="contact-card">
          <a className="btn-primary" href={`mailto:${COMPANY.email}`}>
            {COMPANY.email}
          </a>
          <p className="site-foot-note">
            We read every message. Expect a reply within two working days.
          </p>
        </div>
      </section>

      <section className="band">
        <h2 className="band-title">What to include</h2>
        <p className="band-sub">
          The more of this you can answer, the more accurate the first quote
          is &mdash; and the fewer rounds it takes to get there.
        </p>
        <ul className="svc-items wide">
          <li>What the software needs to do, in your own words</li>
          <li>Which platforms it has to run on</li>
          <li>Whether it handles money, personal data, or both</li>
          <li>Anything that already exists, and whether it stays</li>
          <li>Your rough budget range and any fixed deadline</li>
          <li>Who will maintain it after launch &mdash; you or us</li>
        </ul>
        <p className="band-sub">
          Do not send credentials, API keys or production data in a first
          email. If we need access to something, we will set up a secure way
          to share it.
        </p>
      </section>

      <section className="band">
        <h2 className="band-title">Areas we cover</h2>
        <div className="chips">
          {SERVICES.map((s) => (
            <span key={s.title} className="chip">
              {s.title}
            </span>
          ))}
        </div>
      </section>
    </>
  );
}
